import type from "./types";

export function saveSelectedElements(data: string) {
  return {
    type: type.SEGMENT_LOADED_ELEMENTS,
    data
  };
}
export function deleteSelectedSegmentId(data: string) {
  return {
    type: type.DELETE_SELECTED_SEGMENTID,
    data
  };
}
